<template>
  <div class="page-content mail-content">
    <div class="inbox-head d-lg-flex d-block">
      <h3> {{ $t('inbox') }} </h3>
    </div>
    <div class="inbox-body">
      <div class="mail-option">
        <div class="email-filters-left">
          <!-- <div class="chk-all">
            <div class="btn-group">
              <div class="form-check">
                <label class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" name="message[]" :checked="checkAll" @click="toggleCheckAll()"><span class="custom-control-label"></span>
                  <span class="ml-4 mt-1 align-middle uc_first" style="padding-left: 10px;">
                    {{ $t('select_all') }}
                  </span>
                </label>
              </div>
            </div>
          </div> -->
        </div>
        <div class="email-filters-right ml-auto">
          <span class="email-pagination-indicator" v-if="total && limit">
            Page {{ page }} of {{ Math.ceil(total/limit) }}
          </span>
          <div class="btn-group ml-3">
            <router-link tag="button" type="button" :to="{ path: '/messages/all', query: prevPage }" class="btn btn-secondary btn-border" :disabled="page <= 1">
              <i class="fa fa-angle-left"></i>
            </router-link>
            <router-link tag="button" type="button" :to="{ path: '/messages/all', query: nextPage }" class="btn btn-secondary btn-border" :disabled="(page >= Math.ceil(total/limit))">
              <i class="fa fa-angle-right"></i>
            </router-link>
          </div>
        </div>
      </div>
      <div class="email-list">
        <div class="email-list-item unread general" v-if="messageBanner.subject" @click="$router.push({ path: `/messages/${messageBanner._id}`, query: { general: '1' } })">
          <div class="email-list-actions">
            <div class="d-flex">
            </div>
          </div>
          <div class="email-list-detail">
            <span class="date float-right">{{ moment(messageBanner.createdAt).format('LLL') }}</span>
            <span class="from">{{ messageBanner.subject }}</span>
            <br><span class="badge badge-warning mt-2">{{ getCategory(messageBanner) }}</span>
            <p class="msg">{{ messageBanner.content.replace(regularExp, '').length > 200 ? messageBanner.content.replace(regularExp, '').substring(0, 200) + '...' : messageBanner.content.replace(regularExp, '') }}</p>
          </div>
        </div>

        <div class="email-list-item"  v-for="(message, index) in messages" v-bind:key="`message_${index}`" :class="{'unread': !message.read }" @click="goToMessage(message)">
          <div class="email-list-actions">
            <div class="d-flex">
              <!-- <label class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" :value="message._id" name="message[]" :checked="message.checked" @click="toggle(message)"><span class="custom-control-label"></span>
              </label> -->
            </div>
          </div>
          <div class="email-list-detail">
            <span class="date float-right">{{ moment(message.createdAt).format('LLL') }}</span>
            <span class="from">{{ message.subject }}</span>
            <br><span class="badge mt-2" :class="$route.query.general ? 'badge-warning' : 'badge-secondary'">{{ getCategory(message) }}</span>
            <p class="msg">{{ message.content.replace(regularExp, '').length > 200 ? message.content.replace(regularExp, '').substring(0, 200) + '...' : message.content.replace(regularExp, '') }}</p>
          </div>
        </div>
        <div class="email-list-item text-center" v-if="!messageBanner.subject && !messages.length">
          <div class="email-list-detail">
            {{ $t('no_messages') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import Message from '../services/messages'

export default {
  name: 'MessagesList',
  data: function () {
    return {
      moment: moment,
      messages: [],
      messageBanner: {
        subject: '',
        content: '',
        createdAt: ''
      },
      limit: 10,
      page: 1,
      total: 0,
      unread: null,
      category: null,
      checkAll: false,
      nextPage: {},
      prevPage: {},
      categories: [
        { id: 0, name: 'Dashboard' },
        { id: 1, name: this.$t('distribution') },
        { id: 2, name: this.$t('bank') },
        { id: 3, name: this.$t('subscription') },
        { id: 4, name: this.$t('claims') }
      ],
      mode: null,
      regularExp: /(<([^>]+)>)/ig
    }
  },
  methods: {
    getMessages: function () {
      this.$eventBus.$emit('loadingMessages')
      this.messageBanner = {
        subject: '',
        content: '',
        createdAt: ''
      }
      if (this.$route.query.page) {
        this.page = parseInt(this.$route.query.page)
      }
      if (this.$route.query.limit) {
        this.limit = this.$route.query.limit
      }
      let params = {
        page: this.page - 1,
        limit: this.limit
      }
      if (this.$route.query.general) {
        Message.getAllGenerals(params).then(response => {
          this.messages = response.data.items
          this.total = response.data.total

          this.prevPage = { page: this.page - 1, limit: this.limit }
          this.nextPage = { page: this.page + 1, limit: this.limit }

          this.$eventBus.$emit('loadedMessages')
        })
      } else {
        this.unread = null
        delete params.unread
        if (this.$route.query.unread) {
          this.unread = 1
          params.unread = 0
        }
        this.category = null
        delete params.type
        if (this.$route.query.category === 0) {
          this.category = 0
          params.type = 0
        }
        if (this.$route.query.category === 1) {
          this.category = 1
          params.type = 1
        }
        if (this.$route.query.category === 2) {
          this.category = 2
          params.type = 2
        }
        if (this.$route.query.category === 3) {
          this.category = 3
          params.type = 3
        }
        if (this.$route.query.category === 4) {
          this.category = 4
          params.type = 4
        }
        Message.getAll(params).then(response => {
          this.messages = response.data.items
          this.total = response.data.total
          this.messageBanner = response.data.banner

          this.prevPage = { page: this.page - 1, limit: this.limit }
          if (this.unread) {
            this.prevPage.unread = this.unread
          }
          if (this.category) {
            this.prevPage.category = this.category
          }

          this.nextPage = { page: this.page + 1, limit: this.limit }
          if (this.unread) {
            this.nextPage.unread = this.unread
          }
          if (this.category) {
            this.nextPage.category = this.category
          }

          this.$forceUpdate()

          this.$eventBus.$emit('loadedMessages')
        })
      }
    },
    toggle: function (message) {
      message.checked = !message.checked
      this.checkAll = false
      this.$forceUpdate()
    },
    toggleCheckAll: function () {
      this.checkAll = !this.checkAll
      _.each(this.messages, item => {
        item.checked = this.checkAll
      })
      this.$forceUpdate()
    },
    getCategory: function (message) {
      return message.subject ? _.filter(this.categories, elem => elem.id === message.type)[0].name : ''
    },
    goToMessage: function (message) {
      // Use a regular expression to find all anchor tags in the message content
      const linkRegex = /<a href="([^"]+)" target="_blank">/g
      const links = []
      let match

      // Find all matches for links
      while ((match = linkRegex.exec(message.content)) !== null) {
        links.push(match[1]) // Extract the URL from the regex match
      }

      // If there are any links, open the first one in a new tab
      if (links.length > 0) {
        this.$router.push({path: links[0]}) // Open the first link found
      } else {
        // If no links, handle it as a regular message (you can modify this as needed)
        this.$router.push({ path: `/messages/${message._id}` })
      }
    }
  },
  created: function () {
    this.getMessages()
  },
  mounted: function () {
    this.$forceUpdate()
  },
  watch: {
    '$route': function (from, to) {
      if (to) {
        this.getMessages()
        this.$forceUpdate()
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .uc_first {
    text-transform: capitalize;
  }
  .mail-wrapper {
    .mail-content {
      .inbox-body{
        .email-list {
          .email-list-item {
            &.unread.general{
              &:after {
                background: #FFAB00;
              }
            }
          }
        }
      }
    }
  }
  .btn-secondary {
    &:disabled {
      i {
        color: #fff;
      }
    }
    &:hover {
      i {
        color: #7289da;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MessagesList.vue